import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  DeployedVoice,
  DeployedVoiceResponse,
  UpsertDeployedVoice,
} from './types';

export const getDeployedVoices = (accountId: string, projectId: string) => {
  return doGet<DeployedVoiceResponse>(
    generateNextPath(ENDPOINTS.DEPLOYED_VOICES, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    {
      version: 'v2',
    },
  );
};

export const deleteDeployedVoice = (
  accountId: string,
  projectId: string,
  deployedVoiceId: string,
) => {
  return doDelete<{ success: boolean }>(
    generateNextPath(ENDPOINTS.DEPLOYED_VOICE, {
      accountId,
      projectId,
      deployedVoiceId,
    }),
    LOGGER_TYPE.JUPITER,
    {},
    {
      version: 'v2',
    },
  );
};

export const upsertDeployedVoice = (
  accountId: string,
  projectId: string,
  upsertDeployedVoice: UpsertDeployedVoice,
) => {
  return doPut<DeployedVoice>(
    generateNextPath(ENDPOINTS.DEPLOYED_VOICES, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    upsertDeployedVoice,
    {
      version: 'v2',
    },
  );
};
